import React from 'react';
import { NB } from '@cerebral-inc/ui';
import Check from './images/check.svg';
import { getStaticFilePath } from '../utils';

const { Pressable, Box, Text, Image } = NB;

interface CheckboxProps {
  children: React.ReactNode;
  checked: boolean;
  onChange: () => void;
}

export const Checkbox = ({
  children,
  checked,
  onChange
}: CheckboxProps): JSX.Element => (
  <Pressable display="flex" flexDirection="column" onPress={onChange} py="15px">
    <Text h={0}>
      <Box
        position="absolute"
        w="16px"
        h="16px"
        bg={checked ? 'c_primary.600' : '#fff'}
        borderRadius="4px"
        borderStyle="solid"
        borderWidth="1px"
        borderColor="c_primary.600"
      >
        <Image
          src={getStaticFilePath(Check)}
          display={checked ? 'block' : 'none'}
          w="16px"
          h="16px"
          color="white"
          top="-1px"
        />
      </Box>
    </Text>

    <Text
      fontSize="12px"
      color="c_grey.900"
      lineHeight="16px"
      fontWeight="400"
      ml="24px"
      onPress={onChange}
    >
      {children}
    </Text>
  </Pressable>
);
